/*
 * @Description: 路由相关 store
 * @Author: erickuang
 * @Date: 2021-08-17 16:14:59
 * @LastEditor: erickuang
 * @LastEditTime: 2021-11-22 14:28:14
 */

import { RouteChangeTransitionType } from '@/types/global';

export interface State {
  lastRouteName: string;
  refPg: string;
  routeChangeTransitionType: RouteChangeTransitionType;
}

const state: State = {
  lastRouteName: '',
  refPg: '',
  routeChangeTransitionType: RouteChangeTransitionType.Normal,
};

const mutations = {
  updateLastRouteName(state: State, routeName: string) {
    state.lastRouteName = routeName;
  },
  updateRefPg(state: State, refPg: string) {
    state.refPg = refPg;
  },
  updateRouteTransitionType(state: State, transitionType: RouteChangeTransitionType) {
    state.routeChangeTransitionType = transitionType;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
